import { createFileRoute, Outlet } from "@tanstack/react-router";
import * as Sentry from "@sentry/react";

import { authenticate } from "@/app/lib/api/api";
import { CommonTrackingEvents, rudderAnalytics } from "@/app/lib/rudderstack";
import { decode } from "@/app/lib/utils/tokens";

export const Route = createFileRoute("/_authenticated")({
  component: RouteComponent,
  beforeLoad: async () => {
    const accessToken = await authenticate();

    const { userId } = decode(accessToken);
    Sentry.setUser({ id: userId });
    rudderAnalytics.identify(userId);
  },
  onEnter: () => {
    rudderAnalytics.track(CommonTrackingEvents.USER_OPENED_APP);
  },
});

function RouteComponent() {
  return <Outlet />;
}
